"use strict";

var __spreadValues = window.__spreadValues;
var __defNormalProp = window.__defNormalProp;
var __propIsEnum = window.__propIsEnum;
var __hasOwnProp = window.__hasOwnProp;
var __getOwnPropSymbols = window.__getOwnPropSymbols;
var __defProp = window.__defProp;
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
class ConfirmModal extends Backbone.View {
  static initClass() {
    this.prototype.template = "core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal";
    this.prototype.events = {
      "click .js-confirm-modal-confirm-button": "_confirmClicked",
      "click .js-confirm-modal-cancel-button": "_cancelClicked"
    };
  }
  initialize(options) {
    this.options = options;
    this.successCallback = this.options.successCallback;
    this.render();
    this.$el.appendTo("body");
    this.ui = {
      $modal: this.$(".confirm-modal")
    };
    const ui = this.ui.$modal.on("hidden.bs.modal", () => this.remove());
    typeof ui.modal === "function" && ui.modal("show");
    return this;
  }
  render() {
    this.$el.append(JST[this.template](this.viewOptions()));
    return this;
  }
  _confirmClicked() {
    this.ui.$modal.modal("hide");
    if (typeof this.successCallback === "function") {
      this.successCallback();
    }
    return this.trigger("confirm");
  }
  _cancelClicked() {
    return this.trigger("cancel");
  }
  remove() {
    this.trigger("close");
    return super.remove();
  }
  viewOptions() {
    const passedInOptions = _.pick(this.options, ["successCallback", "mainText", "subText", "cancelButtonText", "confirmButtonText", "confirmButtonClasses"]);
    const defaultOptions = {
      confirmButtonClasses: "btn-danger"
    };
    return __spreadValues(__spreadValues({}, defaultOptions), passedInOptions);
  }
}
ConfirmModal.initClass();
window.ConfirmModal = ConfirmModal;
window.__defProp = __defProp;
window.__getOwnPropSymbols = __getOwnPropSymbols;
window.__hasOwnProp = __hasOwnProp;
window.__propIsEnum = __propIsEnum;
window.__defNormalProp = __defNormalProp;
window.__spreadValues = __spreadValues;
window.ConfirmModal = ConfirmModal;